// eslint-disable-next-line import/prefer-default-export
export const roundDecimalDigits = (
  value, digits = 2
) => Math.round((value + Number.EPSILON) * 10 ** digits) / (10 ** digits)
